import { useState } from 'react';

import ClassroomAnswerTabs, {
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import ActivitySheet from '../../shared/sheet/activity-sheet';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import DrawResponseSuggestedAnswer from 'approot/activity-builder/classroom/draw/draw-response-suggested-answer';
import useDrawHasSuggestedAnswer from '../use-draw-has-suggested-answer';
import { ViewProps } from '../draw.constants';
import DrawCanvas from '../canvas/draw-canvas';
import * as Styled from '../draw-view.style';
import { SampleProps } from '../../sample/activity-sample.constants';
import { LanguageCodes } from 'global/constants';

const DrawViewSampleAnswer = (
  props: ViewProps &
    SampleProps & {
      language: LanguageCodes;
      closeModal: () => void;
    }
) => {
  const {
    id,
    type,
    properties,
    subActivityProperties,
    suggestedAnswerProperties,
    banner,
    closeModal,
  } = props;

  const [tab, setTab] = useState<string>(QUESTION_VIEW);

  const hasSuggestedAnswer = useDrawHasSuggestedAnswer({
    id,
    suggestedAnswerProperties,
  });

  return (
    <ActivitySheet
      isVisible
      title="Drawing response"
      onClose={closeModal}
      tabsContent={
        <ClassroomAnswerTabs
          isPublished
          canClearModelledResponse={false}
          includeIndividualAnswers={false}
          includeClassResponse={false}
          includeSuggestedAnswers={hasSuggestedAnswer}
          tab={tab}
          onSelect={option => setTab(option)}
          componentId={id}
          onCloseActivitySheet={closeModal}
        />
      }
      banner={banner}
    >
      {tab === QUESTION_VIEW && (
        <Styled.DrawViewTeacher id="content">
          <DrawCanvas
            id={id}
            type={type}
            language={props.language}
            imageUrl={properties.image?.original}
            dimensionsData={properties.dimensionData}
            subActivityProperties={subActivityProperties}
            questionData={properties.draw}
          />
        </Styled.DrawViewTeacher>
      )}
      {tab === SUGGESTED_VIEW && (
        <ActivitySheetInnerContent id="content">
          <ActivitySheetInnerMax>
            <DrawResponseSuggestedAnswer component={props} />
          </ActivitySheetInnerMax>
        </ActivitySheetInnerContent>
      )}
    </ActivitySheet>
  );
};

export default DrawViewSampleAnswer;
